// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Avatar, Box, Divider, Group, Space, Stack, Text } from '@mantine/core';
import PanePaper from '../../../Molecules/PanePaper';

export const thankYouParagraphs = [
  'Mit Deinem Upgrade auf einen bezahlten Plan hast Du Dir Deine Büroarbeit als Eventdienstleister in so vielen Bereichen deutlich vereinfacht. Durch Dein Upgrade unterstützt Du zudem unsere Mission, das beste Eventverwaltungstool am Markt zu entwickeln.',
  'Mein Team und ich wünschen Dir allzeit gute Geschäfte und erfüllende Aufträge, egal ob vor, hinter oder auf der Bühne!',
];

const sebastianAvatarUrl = 'https://gitlab.home.sebastianmahlke.de/uploads/-/system/user/avatar/2/avatar.png?width=192';

export const ThankYouCitation = () => (
  <>
    <Divider
      sx={(theme) => ({
        borderTopColor: theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3],
      })}
    />
    <Box
      component="figure"
      m={0}
      sx={{
        position: 'relative',
        borderRadius: 8,
      }}
    >
      <Group
        align="flex-start"
        spacing="md"
        noWrap
        sx={{
          '@media (max-width: 520px)': {
            alignItems: 'stretch',
            flexDirection: 'column',
          },
        }}
      >
        <Avatar
          color="blue"
          radius="xl"
          size={46}
          src={sebastianAvatarUrl}
          sx={{
            flex: '0 0 auto',
            '@media (max-width: 520px)': {
              display: 'none',
            },
          }}
        >
          <Text color="white" weight={800} size="sm">
            SM
          </Text>
        </Avatar>
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Box
            component="blockquote"
            m={0}
            sx={(theme) => ({
              position: 'relative',
              paddingLeft: 14,
              borderLeft: `3px solid ${theme.colorScheme === 'dark' ? theme.colors.dark[4] : theme.colors.gray[3]}`,
            })}
          >
            <Stack spacing={8} sx={{ position: 'relative' }}>
              {thankYouParagraphs.map((paragraph) => (
                <Text key={paragraph} size="xs" color="dimmed" italic sx={{ lineHeight: 1.55 }}>
                  {paragraph}
                </Text>
              ))}
            </Stack>
          </Box>
          <Box component="figcaption" mt="sm">
            <Group
              position="apart"
              spacing="xs"
              sx={{
                '@media (max-width: 520px)': {
                  alignItems: 'flex-start',
                  flexDirection: 'column',
                },
              }}
            >
              <Text sx={{ fontFamily: 'SafiarSignature, Courier', fontSize: 26, lineHeight: 1 }}>Sebastian Mahlke</Text>
              <Text color="dimmed" size="xs" weight={700} transform="uppercase">
                Geschäftsführer
              </Text>
            </Group>
          </Box>
        </Box>
      </Group>
    </Box>
  </>
);

const ThankYou = () => (
  <PanePaper title="Danke, dass Du Dich für bookitup entschieden hast.">
    <Text>{thankYouParagraphs[0]}</Text>
    <Space h="md" />
    <Text>{thankYouParagraphs[1]}</Text>
    <Space h="md" />
    <div style={{ fontFamily: 'SafiarSignature, Courier', fontSize: 30, textAlign: 'right' }}>Sebastian Mahlke</div>
    <Text mr="xl" color="dimmed" align="right">
      Geschäftsführer
    </Text>
  </PanePaper>
);

export default ThankYou;
